import { Card, Heading } from '@shopify/polaris';
import React, { Component } from 'react';
import suggests from './suggests';
import './styles.scss';

class Suggests extends Component {
    generalArrayRates = (rate) => {
        let rates = [];
        for (let i = 1; i <= 5; i++) {
            if (i < rate && rate < i + 1) {
                rates.push(0.5);
                continue;
            }
            if (rate >= i) {
                rates.push(1);
                continue;
            }
            if (rate < i) {
                rates.push(0);
                continue;
            }
        }
        return rates;
    };
    render() {
        return (
            <div className="yta-suggests">
                <div className="page-wrapper">
                    <Card sectioned>
                        <Card.Section>
                            <Heading>Often installed with apps</Heading>
                            <div className="yta-suggests-body">
                                {suggests.map((item, index) => (
                                    <div className="yta-suggests-item" key={index}>
                                        <a alt={item.title} href={item.url} target="_blank">
                                            <img alt={item.title} src={item.logo}></img>
                                        </a>
                                        <div className="yta-suggests-item-body">
                                            <a alt={item.title} href={item.url} target="_blank">
                                                <div className="yta-suggests-item-title">
                                                    <Heading>{item.title}</Heading>
                                                </div>
                                            </a>
                                            <div className="yta-suggests-item-plan">
                                                {item.plan}
                                            </div>
                                            <div className="yta-suggests-item-subtitle">
                                                {item.subtitle}
                                            </div>
                                            <div className="yta-suggests-item-rates">
                                                {this.generalArrayRates(item.rate).map(
                                                    (_item, _index) => (
                                                        <div
                                                            key={_index}
                                                            className={`rate rate-${
                                                                _item === 1
                                                                    ? 'full-star'
                                                                    : _item === 0.5
                                                                    ? 'half-star'
                                                                    : 'empty-star'
                                                            }`}
                                                        ></div>
                                                    ),
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Card.Section>
                    </Card>
                </div>
            </div>
        );
    }
}

export default Suggests;
